import { GENERAL_EVENTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";

Vue.use(Vuetify);
@Component({
  name: "TooltipButton"
})
export default class TooltipButton extends Vue {
  @Prop({ default: "" })
  private hintText!: string;
  @Prop({ default: "" })
  private icon!: string;
  @Prop({ default: false })
  private disabled!: boolean;
  @Prop({ default: STYLE_CLASSES.TERTIARY_ROUND_BTN })
  private btnClass!: string;
  @Prop({ default: undefined })
  private btnColor!: string;
  @Prop({ default: undefined })
  private iconColor!: string;
  @Prop({ default: false })
  private xsmall!: boolean;

  click() {
    this.$emit(GENERAL_EVENTS.CLICK);
  }
}
